import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=f5eac5a6&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=js"
export * from "./ChatMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=f5eac5a6&prod&scoped=true&lang=css"
import style1 from "./ChatMessage.vue?vue&type=style&index=1&id=f5eac5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eac5a6",
  null
  
)

export default component.exports